export const Marquee = ({ items = [], dark = false }) => {
  const list = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-lab whitespace-nowrap px-8 text-[11px] uppercase tracking-[0.24em]">{item}</span>
          <span className={`h-1.5 w-1.5 rotate-45 ${dark ? "bg-[#0e8c8c]" : "bg-[#0e8c8c]"}`} />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className={`overflow-hidden border-y py-4 ${
        dark ? "border-white/10 bg-[#070b0c] text-white/70" : "border-[#e4e9ec] bg-[#fafafa] text-[#56636b]"
      }`}
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {list(false)}
        {list(true)}
      </div>
    </div>
  );
};

export default Marquee;